var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.model_buttons),function(button){return _c('div',{key:button.id,staticStyle:{"float":"left"}},[_c('model-button',{attrs:{"selected":_vm.selected_model_type===button.id,"name":button.name,"disabled":_vm.disabled},nativeOn:{"click":function($event){return _vm.on_click(button)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }